export default __webpack_public_path__ + "static/media/game_chat.a3a74c36.mp3";